module.exports = __webpack_public_path__ + "static/media/corona_assist_manager.9313ba53.png";